import React, { ComponentType, FunctionComponent, useContext } from "react";

import { Subtract } from "utility-types";
import { IWithMergeContextProps } from "./IWithMergeContextProps";
import { MergeContext } from "./MergeContext";

export function WithMergeContext<P extends IWithMergeContextProps>(
  Component: ComponentType<P>
): FunctionComponent<Subtract<P, IWithMergeContextProps>> {
  function ComponentWithContext(props: Subtract<P, IWithMergeContextProps>) {
    const context = useContext(MergeContext);
    return <Component {...(props as P)} {...context} />;
  }

  const componentName = Component.displayName ?? Component.name ?? `Component`;
  ComponentWithContext.displayName = `WithMergeContext(${componentName})`;
  return ComponentWithContext;
}
